export enum ClaimPhoneNumberPage {
  PHONE_NUMBER,
  VERIFICATION,
  COMPLETE,
}

export type ClaimPhoneNumberFormValues = {
  page: ClaimPhoneNumberPage
  phoneNumber: string
  segments: string[]
  verificationChannel: string
  verificationCode: string
}

export const claimPhoneNumberDefaultValues = {
  page: ClaimPhoneNumberPage.PHONE_NUMBER,
  phoneNumber: '',
  segments: ['', '', '', '', '', ''],
  verificationChannel: 'sms',
  verificationCode: '      ',
}
